import { useContext } from 'react';
import { getLabel } from '../../data/labels';
import { formatDate, getCheckbetUrl, getConfiguration, getCurrencySymbol, getHiddenTicket, getPrintableAmount, oddToString } from '../../data/utils';
import { CashoutConfigurationContext } from '../cashout/CashoutConfigurationCtx';
import { TicketPrinterContext } from '../printer/TicketPrinterContext';
import { MyBetsContext } from './MyBetsContext';
import SocialShareButtons from './SocialShareButtons';
import Winnings from './Winnings';
import ReloadTicketSection from './my-bets-layout-2/ReloadTicketSection';
import { getEnv } from '../env';

function getTicketType(type) {
    switch (type) {
        case 'singlebets':
            type = getLabel('mybets.singola');
            break;
        case 'multibets':
            type = getLabel('mybets.multipla');
            break;
        case 'systembets':
            type = getLabel('mybets.sistema');
            break;
        default:
            break;
    }
    
    return type;
}

function BetInfo(props) {
    const ticket = props.ticket;
    const conf = getConfiguration();
    const cashoutConfigurationContext = useContext(CashoutConfigurationContext);
    const printTicketEnabled = conf.pto !== undefined? conf.pto : true;
    const currency = getCurrencySymbol(conf.cs.ct);
    const isCashoutable = (cashoutConfigurationContext.cashoutData.enabled && ticket.isCashoutable && !props.isCheckbet);
	const myBetsContext = useContext(MyBetsContext);
	const printerContext = useContext(TicketPrinterContext);
    const ticketUrl = getCheckbetUrl(ticket.id);
    const amount = getPrintableAmount(ticket.cashoutAmount, conf.cs.m, conf.cs.nd);
    const amountWithCurrency = `${amount} ${currency}`;
    const bonusAmount = ticket.bonusAmount || props.ticketData?.bonusAmount;
    
    let disclaimerCashout = getLabel('cashout.disclaimer');
    disclaimerCashout = disclaimerCashout.replace(/{{AMOUNT}}/g, amountWithCurrency);
    
    const totalOdd = props.isBetBuilder? ticket.betBuilderTotalOdd : ticket.totalOdds;

    return (
        <>
            <div className="bet-info d-flex justify-content-space-between align-items-center">
            	{totalOdd > 0 &&
                    <div className="d-flex flex-column text-small">
                        <span className="grey">{getLabel('mybets.quotatotale')}</span><span className="text-medium bold">{oddToString(totalOdd)}</span>
                    </div>
            	}
                {ticket.openedEventsNumber > 0 && ticket.totalEventsNumber > 0 &&
                    <div className="d-flex flex-column text-small">
                        <span className="grey">{getLabel('mybets.selezioni_aperte')}</span><span className="justified-text text-medium bold">{`${ticket.openedEventsNumber}/${ticket.totalEventsNumber}`}</span>
                    </div>
                }
                <div className="d-flex flex-column text-small">
                    <span className="grey">{getLabel('mybets.importo')}</span><span className="text-medium bold">{getPrintableAmount(ticket.amount, conf.cs.m, conf.cs.nd)} {currency}</span>
                </div>
                {bonusAmount > 0 &&
                <div className="d-flex flex-column text-small">
                    <span className="grey">{getLabel('general.bonus')}</span><span className="text-medium bold">{getPrintableAmount(bonusAmount, conf.cs.m, conf.cs.nd)} {currency}</span>
                </div>
                }
                
                <Winnings {...ticket} />
            </div>
            <hr />
            {isCashoutable &&
                <>
                    <div className="bet-info d-flex justify-content-space-between align-items-center">
                        <div className="d-flex flex-column text-small  var-disclaimer-wh">
                            <span className="justified-text text-medium bold">
                                {disclaimerCashout}
                            </span>
                        </div>
                        <button onClick={() => { myBetsContext.showPreCashoutDisclaimer(ticket.id, ticket.amount, ticket.cashoutAmount, ticket.isLive)}} className="bottone bet-info bg-verde bianco maiuscolo bet-info-wh">
                            <span className="moneyIconContainer">
                                <i className="fas fa-money-bill-wave-alt"></i>
                            </span>
                            {getLabel('cashout.button_text')} {conf.iwh && amountWithCurrency }
                        </button>
                    </div>
                    <hr />
                </>
            }
        	{!(window?.appConfig?.SHOP_MODE) &&
                <>
	        		<div className="bet-info d-flex justify-content-space-between align-items-center">
		        		<div className="d-flex flex-column text-small var-disclaimer">
		        			<span className="bet-info-buttons-container  justified-text text-medium bold">
                                {printTicketEnabled &&
    		        				<div className="my-bets-printer" onClick={() => printerContext.printTicket(ticket.id, false)}>
                                        <img src={`${getEnv('PUBLIC_URL')}/assets/images/print.svg`} alt="Print button" />
                                    </div>
                                }
                                <SocialShareButtons ticketUrl={ticketUrl} />
                                <ReloadTicketSection isCheckbet={props.isCheckbet} ticket={props.ticket} />
		        		    </span>
		        		</div>
		        		{/*
			    			<button onClick={() => { openCashout()}} className="bottone bet-info bg-arancio bianco maiuscolo">
			    				{getLabel('checkbet.button')}
			    				<span className="checkbetIconContainer">
			    				<i className="fa fa-caret-right"></i>
			    				</span>
			    			</button>	
		        		 */}
	        		</div>
	        		<hr />
        		</>
        	}
            <div className="d-flex justify-content-space-between align-items-center margin-top text-small grey">
                <span>{getTicketType(ticket.type)}</span>
                <div className="d-flex justify-content-space-between">
                    <span>Ref. {props.obfuscateTicketId?getHiddenTicket(ticket.id):ticket.id}</span>
                    <span className="margin-left-right">|</span>
                    <span>{formatDate(ticket.timestamp).formatted}</span>
                </div>
            </div>
        </>
    );
}

export default BetInfo;